import { Component, Input } from '@angular/core';
import { CountBoxIndicatorComponent } from '../../molecules/count-box-indicator/count-box-indicator.component';
import { CountBoxLayerTypeComponent } from '../../molecules/count-box-layer-type/count-box-layer-type.component';
import { CountBoxPoiComponent } from '../../molecules/count-box-poi/count-box-poi.component';
import { CountBoxDataLayerComponent } from '../../molecules/count-box-data-layer/count-box-data-layer.component';
import { CountBoxDataComponent } from '../../molecules/count-box-data/count-box-data.component';

@Component({
  selector: 'app-count-overview',
  standalone: true,
  imports: [
    CountBoxIndicatorComponent,
    CountBoxLayerTypeComponent,
    CountBoxPoiComponent,
    CountBoxDataLayerComponent,
    CountBoxDataComponent,
  ],
  templateUrl: './count-overview.component.html',
  styleUrl: './count-overview.component.scss',
})
export class CountOverviewComponent {
  @Input() styleClass?: string = 'flex align-items-baseline w-full flex-wrap';
}
